module.exports = __webpack_public_path__ + "img/group-11.c9ffd610.svg";